import { ListItem, ListTitle, ListUrl } from './styles'

export const NavItem = ({ name, url }) => (
  <ListItem>
    <ListUrl href={url}>{name}</ListUrl>
  </ListItem>
)

export const NavTitle = ({ name }) => <ListTitle>{name}</ListTitle>
